import { defineMessages } from 'react-intl';

export default defineMessages({
    whatTitle: {
        id: 'tdic.fnol.wizard.step.cl.What',
        defaultMessage: 'What'
    },
    WhereTitle: {
        id: 'tdic.fnol.wizard.step.cl.Where',
        defaultMessage: 'Where'
    }
});
